import type { ReactChild } from 'react';
import { hasError } from '../../utils';
import { ErrorAlert } from './ErrorAlert';
import type { UseAsyncStatus } from '../../hooks/useAsyncStatus';

type AdminCardBodyProps = {
  children: ReactChild | undefined;
  useAsyncStatuses: UseAsyncStatus[];
  initialUseAsyncStatuses: UseAsyncStatus[];
};

export const AdminCardBody = ({
  children,
  useAsyncStatuses,
  initialUseAsyncStatuses,
}: AdminCardBodyProps) => {
  const isLoading = initialUseAsyncStatuses.find(({ status }) => status.loading);

  return (
    <>
      {useAsyncStatuses.map(({ status }) => hasError(status) && <ErrorAlert status={status} />)}
      {isLoading && 'Loading...'}
      {!isLoading && children}
    </>
  );
};
